/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Address } from './address.model';


export class CourtLocation {
    ngiCantonCode: string; // ecf001
    districtCode: string;
    preferredLanguage: string; //ecf001
    language: string[];
    preferred: boolean; // ecf001
    bankAccount: string; // ecf001
    bankAccountBic: string;
    description: CourtLocationDescription[];
    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    constructor() {
        this.description = [];
    }

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): CourtLocation {
        if (!data) { return instance; }
        if (data.ngiCantonCode != null) {instance.ngiCantonCode = data.ngiCantonCode; }
        if (data.districtCode != null) {instance.districtCode = data.districtCode; }
        if (data.preferred != null) {instance.preferred = data.preferred; }
        if (data.preferredLanguage != null) {instance.preferredLanguage = data.preferredLanguage; }
        if (data.bankAccount != null) {instance.bankAccount = data.bankAccount; }
        if (data.bankAccountBic != null) {instance.bankAccountBic = data.bankAccountBic; }
        if (data.description != null) {
            instance.language = [];
            instance.description = [];
            ([].concat(data.description)).forEach(description => {
                const jsonDescription = new CourtLocationDescription().fromJSON(description);
                instance.description.push(jsonDescription); // i3
                if(!!description.language && !instance.language.includes(description.language)){
                    instance.language.push(description.language)
                }; 
            });
        }
        
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return CourtLocation.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: CourtLocation) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return CourtLocation.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: CourtLocation): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}

export class CourtLocationDescription{
    name: string; // ecf001
    phone?: string; // ecf001
    openhours?: string; // ecf001
    email?: string; // ecf001
    district: string; // ecf001
    language?: string; // ecf001
    address: Address; // ecf001

    
    public static mergeJSON(instance: any, data: any): CourtLocationDescription {
        if (!data) { return instance; }
        if (data.name != null) {instance.name = data.name; }
        if (data.phone != null) {instance.phone = data.phone; }
        if (data.openhours != null) {instance.openhours = data.openhours; }
        if (data.email != null) {instance.email = data.email; }
        if (data.district != null) {instance.district = data.district; }
        if (data.language != null) {instance.language = data.language; }
        if (data.address != null) {instance.address = new Address().fromJSON(data.address); } // i8
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return CourtLocationDescription.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: CourtLocationDescription) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return CourtLocationDescription.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: CourtLocationDescription): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}


/** end of template "model.velocity" */
